import camelcase from 'camelcase';

import { hierarchyShorteningRules, locale } from '../app-constants';

import { isNullOrUndefined } from './utils.object';

export const isEmptyOrWhiteSpace = (value: string): boolean =>
	isNullOrUndefined(value) || value.trim() === '';

export const toCamelCase = (value: string): string =>
	camelcase(value, {
		preserveConsecutiveUppercase: true,
		locale
	});

export const toPascalCase = (value: string): string =>
	camelcase(value, {
		preserveConsecutiveUppercase: true,
		pascalCase:                   true,
		locale
	});

export const escapeRegex = (value: string): string =>
	value?.replace(/[.*+?^${}()|[\]\\]/g, String.raw`\$&`);

export const removeSpecials = (value: string): string =>
	value?.replace(/[^a-zA-Z0-9а-яА-Я ]/g, '');

export const toHierarchyString = (value: string): string => {
	if (isNullOrUndefined(value)) {
		return value;
	}

	let result = removeSpecials(value).toUpperCase();

	// Apply replacements (longest keys first to avoid partial matches)
	const keys = Object.keys(hierarchyShorteningRules).sort(
		(a, b) => b.length - a.length
	);

	for (const key of keys) {
		result = result.replace(
			new RegExp(String.raw`\b${escapeRegex(key)}\b`, 'g'),
			hierarchyShorteningRules[key]
		);
	}

	return result.replace(/\s/g, '');
};
